import BrainBulb from '@/components/svg/BrainBulb'
import Farmer from '@/components/svg/Farmer'
import Handshake from '@/components/svg/Handshake'

export const STRINGS = {
  TITLE: 'About DeHaat',
  DESCRIPTION:
    'The fastest-growing AI-enabled start-up in Agricultural Technology sector. Founded by the alumni from IIT Delhi, IIT Kharagpur, IIM Ahmedabad and other top institutes.',
  HEADING: 'About Us',
  ABOUT_DEHAAT_DETAILED: `DeHaat™ is one of the fastest-growing start-ups in the Agri-Tech sector & one of the very few companies providing end-to-end solutions & services to the farming community in India. We are building AI-enabled technologies to revolutionize supply chain & production efficiency in the farming sector.\n\nCurrently, we are operating in <@>12</@> Indian agrarian states with an extensive network of <@>11,000+</@> DeHaat Centers & <@>503</@> FPOs, serving <@>1.8 million+</@> farmers. We also provide AI-enabled crop advisory to farmers for <@>30+</@> crops in regional languages.\n\nFounded by the alumni from IIT Delhi, IIT Kharagpur, IIM Ahmedabad & other top institutes - DeHaat is a fully funded start-up with an exceptional growth rate & is certified <@>Great Place to Work 2 years in a row</@>, 2022-2023 & 2023-2024. The impact we have created at grass root level over the last 12 years of our operations has been phenomenal  & is recognized & felicitated by <@>NASSCOM, Forbes, ET, Niti Aayog, Bill Gates Foundation</@> & many more.`,
  ABOUT_DEHAAT_FELICIATED_BY:
    'NASSCOM, Forbes, ET, Niti Aayog, and Bill Gates Foundation, and many more.',
  OUR_VALUES: 'Our Values',
  OUR_VALUES_SUBHEADING:
    'Strengthening Our Roots | Nurturing Our Drive | Harvesting Our True Purpose',
  RESPECT: 'Respect',
  INNOVATION_AND_CREATIVITY: 'Innovation & Creativity',
  FARMER_FIRST: 'Farmer First',
  UPHOLD_INTEGRITY_OF_ORGANIZATION:
    'To uphold the integrity of this organization.',
  ACCOUNTABLE_FOR_MY_ACTIONS: 'To be accountable for my actions.',
  PROMOTE_DIVERSITY:
    'To promote diversity & create an equitable & inclusive work culture.',
  WORK_COLLABORATIVELY: 'To work collaboratively without hierarchy.',
  PROBLEM_SOLVING: 'To have a passion for problem solving.',
  CHALLENGE_AND_CONTINUOUS_SELF_IMPROVE:
    'To challenge the status-quo & focus on continuously improving myself.',
  PUT_FARMER_FIRST: 'To put the needs of farmers above everything else.',
  EMPOWER_FARMERS: 'To think of innovative ways to empower farmers.',
  ABOVE_AND_BEYOND:
    'To go above & beyond in order to provide solutions to farmer issues.',
  DEHAAT_FOUNDERS:
    'DeHaat founders (from left) Shashank Kumar, Amrendra Singh, Adarsh Srivastava and Shyam Sundar Singh',
  MUTUAL_RESPECT: 'Mutual Respect',
  BELIEVE_IN_POWER_OF_MUTUAL_RESPECT:
    'We believe in the power of mutual respect to maintain an honest, transparent and meaningful relationship with our stakeholders.',
  INTEGRITY_ACCOUNTABILITY: 'Practice Integrity, Drive Accountability',
  OWNERSHIP_TO_ACHIEVE_GOAL:
    'We practice integrity, drive accountability and ownership to achieve our common goals and maximize employee potential.',
  DIVERSE_EQUITABLE_INCLUSIVE: 'Diverse, Equitable & Inclusive Culture',
  EMBRACE_DIVERSITY:
    'We embrace diversity across cultural background, race, religion, caste, gender, opinions, & views as the core of our culture.',
  WORK_COLLABORATIVELY_WITHOUT_HIERARCHY:
    'Work Collaboratively without Hierarchy',
  FASTER_COLLABORATION_AND_TEAMWORK:
    'We foster collaboration & teamwork across functions to fulfil a common goal of enhancing & amplifying the mission behind DeHaat. Passion for Problem-Solving',
  PASSION_FOR_PROBLEM_SOLVING: 'Passion for Problem-Solving',
  NURTURE_CREATIVE_IDEAS:
    'We nurture creative ideas to generate solutions for our customers and raise the bar, both within our workplace & throughout the industry.',
  CHALLENGE_STATUS_QUO: 'Challenge Status Quo',
  STRECH_BOUNDARIES:
    'We strive to stretch boundaries, question conventions & have the courage and curiosity to take bold steps, think, dream big and take calculated risks.',
  CONTINUOUS_IMPROVEMENT: 'Continuous Improvement',
  PASSIONATE_ABOUT_LEARNING:
    'We are passionate about learning, seek to constantly improve & innovate,learning from others & from our own challenges & successes.',
  RELENTLESS_FOCUS: 'Relentless Focus on Understanding Farmer Needs',
  UNDERSTANDING_NEEDS_OF_FARMER:
    'We focus on understanding the needs of our farmers & creating solutions that improve their income & quality of life.',
  FARMER_EMPOWERMENT: 'Farmer Empowerment is Paramount',
  CORE_APPROACH_EMPOWERMENT:
    'We put empowerment of our farmers at the core of our approach, technological interventions & product developments.',
  ABOVE_AND_BEYOND_FOR_SOLUTION: 'Go Above & Beyond to Provide Solutions',
  IDEATE_INNOVATE_AND_THINK:
    'We ideate, innovate & think from the perspectives of our farmers and work dedicatedly to create simple & great solutions for them.',
}

export const values = [
  {
    title: STRINGS.RESPECT,
    id: 'respect',
    Icon: Handshake,
    values: [
      STRINGS.UPHOLD_INTEGRITY_OF_ORGANIZATION,
      STRINGS.ACCOUNTABLE_FOR_MY_ACTIONS,
      STRINGS.PROMOTE_DIVERSITY,
    ],
    image: 'respect',
    description: [
      {
        heading: STRINGS.MUTUAL_RESPECT,
        value: STRINGS.BELIEVE_IN_POWER_OF_MUTUAL_RESPECT,
      },
      {
        heading: STRINGS.INTEGRITY_ACCOUNTABILITY,
        value: STRINGS.OWNERSHIP_TO_ACHIEVE_GOAL,
      },
      {
        heading: STRINGS.DIVERSE_EQUITABLE_INCLUSIVE,
        value: STRINGS.EMBRACE_DIVERSITY,
      },
    ],
  },
  {
    title: STRINGS.INNOVATION_AND_CREATIVITY,
    id: 'innovation_and_creativity',
    Icon: BrainBulb,
    values: [
      STRINGS.WORK_COLLABORATIVELY,
      STRINGS.PROBLEM_SOLVING,
      STRINGS.CHALLENGE_AND_CONTINUOUS_SELF_IMPROVE,
    ],
    image: 'innovation-and-creativity',
    description: [
      {
        heading: STRINGS.WORK_COLLABORATIVELY_WITHOUT_HIERARCHY,
        value: STRINGS.FASTER_COLLABORATION_AND_TEAMWORK,
      },
      {
        heading: STRINGS.PASSION_FOR_PROBLEM_SOLVING,
        value: STRINGS.NURTURE_CREATIVE_IDEAS,
      },
      {
        heading: STRINGS.CHALLENGE_STATUS_QUO,
        value: STRINGS.STRECH_BOUNDARIES,
      },
      {
        heading: STRINGS.CONTINUOUS_IMPROVEMENT,
        value: STRINGS.PASSIONATE_ABOUT_LEARNING,
      },
    ],
  },
  {
    title: STRINGS.FARMER_FIRST,
    id: 'farmer_first',
    Icon: Farmer,
    values: [
      STRINGS.PUT_FARMER_FIRST,
      STRINGS.EMPOWER_FARMERS,
      STRINGS.ABOVE_AND_BEYOND,
    ],
    image: 'farmer-first',
    description: [
      {
        heading: STRINGS.RELENTLESS_FOCUS,
        value: STRINGS.UNDERSTANDING_NEEDS_OF_FARMER,
      },
      {
        heading: STRINGS.FARMER_EMPOWERMENT,
        value: STRINGS.CORE_APPROACH_EMPOWERMENT,
      },
      {
        heading: STRINGS.ABOVE_AND_BEYOND_FOR_SOLUTION,
        value: STRINGS.IDEATE_INNOVATE_AND_THINK,
      },
    ],
  },
]
